<template >
    <div class="query">
        <div class="title">
            <p class="return" @click="back">
                <img src="~@public/img/user/login/jian.png"/>
            </p>
            警情信息查询
        </div>
        <!--        <van-cell-group>-->
        <!--            <van-field label="所属市州:" :value="value" placeholder="请选择" readonly is-link @click="showPicker = true"/>-->
        <!--        </van-cell-group>-->
        <!--        <van-cell-group>-->
        <!--            <van-field label="所属区县:" :value="value2" placeholder="请选择" readonly is-link @click="showPicker2 = true"/>-->
        <!--        </van-cell-group>-->
        <van-field v-model="userPhone" clearable readonly label="报警电话:" placeholder="请输入报警电话"/>
        <van-field
                readonly
                required
                clickable
                label="区间时间:"
                :value="cxqj"
                placeholder="选择时间段"
                @click="showPicker = true"
        />
        <van-popup v-model="showPicker" position="bottom">
            <van-picker
                    required
                    show-toolbar
                    :columns="columns"
                    @cancel="showPicker = false"
                    @confirm="onConfirm"
            />
        </van-popup>
<!--        <van-field-->
<!--                v-model="begin_time"-->
<!--                placeholder="开始时间" readonly="readonly"-->
<!--                @click="beginTimePop = true"-->
<!--        />-->
<!--        <van-popup v-model="beginTimePop" label="开始时间" position="bottom" :overlay="true">-->
<!--            <van-datetime-picker-->
<!--                    v-model="begin_date"-->
<!--                    type="datetime"-->
<!--                    @cancel="beginTimePop = false"-->
<!--                    @confirm="startTimeChange"-->
<!--                    :min-date="minDate"-->
<!--                    :max-date="maxDate"-->
<!--            />-->
<!--        </van-popup>-->
<!--        <van-field-->
<!--                v-model="end_time"-->
<!--                placeholder="结束时间" readonly="readonly"-->
<!--                @click="endTimePop = true"-->
<!--        />-->
<!--        <van-popup v-model="endTimePop" label="结束时间" position="bottom" :overlay="true">-->
<!--            <van-datetime-picker-->
<!--                    v-model="end_date"-->
<!--                    type="datetime"-->
<!--                    @cancel="endTimePop = false"-->
<!--                    @confirm="endTimeChange"-->
<!--                    :min-date="minDate"-->
<!--                    :max-date="maxDate"-->
<!--            />-->
<!--        </van-popup>-->
        <van-cell-group>
<!--            &lt;!&ndash;<verification-code-input @setVerificationCode="getVerificationCode"-->
<!--                                     ref="childFunction"></verification-code-input>&ndash;&gt;-->
            <Vue2Verify ref="verify" v-if="show" @closeClick="show = false" @success='success'
                        :imgSize="{width:'310px',height:'155px'}"></Vue2Verify>
        </van-cell-group>
        <div class="btn-submit-div">
            <van-button type="info" size="large" @click="submit()">查询</van-button>
        </div>

        <van-list v-if="listShow" class="list" v-model="loading"
                  :finished="finished"
                  :finished-text="finishedText"
                  @load="pullupLoadMore"
                  :immediate-check="false">
            <div></div>
            <div class="boxList" v-for="(item,index) in List" :key="index" style="border-bottom: 2px solid #868686;">
                <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">警情信息
                </van-divider>
                <div class="boxList-item">
                    <span>接警时间:</span>
                    <span>{{item.jjsj}}</span>
                </div>
                <div class="boxList-item">
                    <span>处警结果:</span>
                    <span>{{item.cjjg}}</span>
                </div>
<!--                <div class="boxList-item">-->
<!--                    <span>报警内容:</span>-->
<!--                    <span>{{item.bjnr}}</span>-->
<!--                </div>-->
<!--                <div class="boxList-item">-->
<!--                    <span>接警单位代码:</span>-->
<!--                    <span>{{item.jjdw}}</span>-->
<!--                </div>-->
                <div class="boxList-item">
                    <span>接警单位名称:</span>
                    <span>{{item.jjdwmc}}</span>
                </div>
                <div class="boxList-item">
                    <span>接警电话:</span>
                    <span>{{item.bjdh}}</span>
                </div>
            </div>
        </van-list>
    </div>
</template>

<script>
    /**
     * Description: 居住证办证进度查询
     * Author: Wangyan
     * Date: 2019-03-25
     * Time: 16:41
     */
    import {CellGroup, Field, Toast, Button, Popup, DatetimePicker, Area, Picker, List, Divider} from 'vant'
    import VerificationCodeInput from "@/components/verification-code-input/VerificationCodeInput";
    import {queryApiMap} from "@/api/query";
    import Vue2Verify from "@/views/signUp/verify/verify"

    export default {

        name: "ResQuery",
        components: {

            Vue2Verify,
            VerificationCodeInput,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Popup.name]: Popup,
            [Toast.name]: Toast,
            [DatetimePicker.name]: DatetimePicker,
            [Picker.name]: Picker,
            [Button.name]: Button,
            [List.name]: List,
            [Area.name]: Area,
            [Divider.name]: Divider

        },
        data() {
            return {
                columns: [
                    {
                        value: "0",
                        text: "近一周内"
                    },
                    {
                        value: "1",
                        text: "近一个月内"
                    },
                    {
                        value: "2",
                        text: "近三个月内"
                    },
                    {
                        value: "3",
                        text: "近半年内"
                    },
                ],
                userPhone:this.$cookie.getUser().telephone,
                uuid:this.$cookie.getUser().trpId,
                finishedText: '', // 加载完毕文本提示
                minDate: new Date(1979, 0, 1),
                maxDate: new Date(),
                end_date: new Date(),
                begin_date: new Date(),
                handlingId: '', // 身份证号
                receiveVerificationCode: {}, // 接收验证码子组件传来verificationInfo对象
                value: '',
                cxqj:'',
                value2: '',
                show: false,
                showPicker: false,
                showPicker2: false,
                listShow: false,
                loading: false, // 是否显示加载loading图标
                List: [],
                pageSize: "10",
                endTimePop: false,
                beginTimePop: false,
                endJJSJ: '', //显示的结束时间
                startJJSJ: '', //显示的开始时间
                begin_time: '',//开始时间的值
                end_time: '',//结束时间的值
                endTimeArr: [], //预约时间集合
                beginTimeArr: [], //预约时间集合
                appointList: [],
                totle: 0,
                page: 1,
                finished: false,
                error: false, // 控制访问接口异常情况下，可以再次重新访问接口

            }
        },
        mounted() {
            this.logger.visit('105', '0')
            this.initUser()
        },
        methods: {
            validator (val) {
                const userPhone = /^1[3456789]\d{9}$/
                return userPhone.test(val)
            },
            onConfirm(value) {
                this.cxqj = value.text;
                this.carType = value.value;
                this.showPicker = false;
            },
            /**
             * 初始化用户
             */
            // 用户信息非必需
            async initUser() {
                let _self = this;
                if (_self.$cookie.getUser()) {
                    return _self.$cookie.getUser();
                }
                let userInfo = {};
                try {
                    const res = await _self.$httpUtils.getGatewayUtils(memberApi.getUserInfo)
                    debugger
                    console.log(res)
                    if (res.data.succ) {
                        userInfo = res.data.data
                        _self.$cookie.setUser(userInfo)
                    } else {
                        Toast.fail('网络异常，请检查网络')
                    }
                } catch (e) {
                    Toast.fail('服务器运行失败，请稍后再试。')
                    console.log(e)
                }
                return userInfo;
            },
            endTimeChange(time) {
                var time1 = '结束时间:       '
                let endTimeArr = [time.getFullYear(), time.getMonth() + 1, time.getDate(), time.getHours(), time.getMinutes()];//["2019", "03", "22", "17", "28"]
                for (var i = 1; i < endTimeArr.length; i++) {
                    if (endTimeArr[i] < 10) {
                        var j = endTimeArr[i]
                        endTimeArr[i] = '0' + j
                    }
                }
                this.end_time = time1 + `${endTimeArr[0]}-${endTimeArr[1]}-${endTimeArr[2]}  ${endTimeArr[3]}:${endTimeArr[4]}:00`
                this.endJJSJ = `${endTimeArr[0]}${endTimeArr[1]}${endTimeArr[2]}${endTimeArr[3]}${endTimeArr[4]}00`
                this.endTimePop = false
            },
            startTimeChange(time) {
                var time2 = '开始时间:       '
                let beginTimeArr = [time.getFullYear(), time.getMonth() + 1, time.getDate(), time.getHours(), time.getMinutes()];//["2019", "03", "22", "17", "28"]
                for (var i = 1; i < beginTimeArr.length; i++) {
                    if (beginTimeArr[i] < 10) {
                        var j = beginTimeArr[i]
                        beginTimeArr[i] = '0' + j
                    }
                }
                this.begin_time = time2 + `${beginTimeArr[0]}-${beginTimeArr[1]}-${beginTimeArr[2]}  ${beginTimeArr[3]}:${beginTimeArr[4]}:00`
                this.startJJSJ = `${beginTimeArr[0]}${beginTimeArr[1]}${beginTimeArr[2]}${beginTimeArr[3]}${beginTimeArr[4]}00`
                this.beginTimePop = false
            },
            /**
             * 点击查询
             */
            submit() {
                this.page = 1
                let _self = this
                const userPhone = /^1[3456789]\d{9}$/
                if (!this.cxqj) {
                    Toast('请选择查询时间段')
                }else if (_self.userPhone===''){
                    Toast('请输入报警电话')
                } else if(!userPhone.test(_self.userPhone)) {
                    Toast('请选择正确的手机号')
                }else {
                    this.show = true
                }
            },
            async success() {
                    Toast.loading({
                        duration: 0,       // 持续展示 toast
                        forbidClick: true, // 禁用背景点击
                        loadingType: 'spinner',
                        message: '查询中...'
                    })
                    try {
                        const data = {
                            userPhone:this.userPhone,
                            uuid:this.uuid,
                            startJJSJ: "",
                            endJJSJ: "",
                            cxqj:this.carType,
                            pageSize: this.pageSize
                        }
                        const res = await this.$httpUtils.getCommonUtils(`${queryApiMap.jjsj}`, data)
                        Toast.clear()
                        this.show = false
                        this.List = []
                        let info = JSON.stringify(res.data.data);
                        if (res.data.succ && res.data.data && info.length > 0) {
                            this.show = false
                            this.listShow = true
                            this.List = res.data.data.records
                            if (this.List.length === 0) { // 无数据提示
                                this.finished = true;
                                this.finishedText = '暂无数据';
                            } else if (this.List.length < parseInt(this.pageSize)) { // 总条目数小于每页条目数提示
                                this.finished = true;
                                this.finishedText = '没有更多啦';
                            }
                        } else {
                            this.finished = true
                            this.loading = false
                            Toast.fail('暂无数据')
                        }
                    } catch (error) {
                        Toast.fail('服务器运行失败，请稍后再试。')
                        console.log(error)
                    }
            },
            pullupLoadMore() {
                this.page++;
                let num = this.pageSize;
                var number = parseInt(num);
                number += 10;
                this.pageSize = number + ''
                this.success()
            },
            back() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>

</style>
<style>
    @import "~@assets/css/public/Common.css";
    .boxList-item{
        align-content: center;
    }
    .boxList-item span {
        line-height: .8rem;
    }

    .boxList-item span:first-child {
        width: 2.2rem;
    }
</style>
